var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"measures"},[_c('artifacts',{attrs:{"from":(_vm.from + "/entities"),"save-with":(_vm.from + "/save"),"default":Object.assign({}, {time_of_measurement: _vm.timeOfMeasurement}, _vm.defaults),"where":{ time_of_measurement: _vm.timeOfMeasurement }},scopedSlots:_vm._u([{key:"element",fn:function(ref){
var element = ref.element;
var remove = ref.remove;
var save = ref.save;
return [_c('editor',{attrs:{"value":element,"save-with":function (copy) { return save({ entity: _vm.stamp(copy) }); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var copy = ref.copy;
var save = ref.save;
return [_vm._t("default",null,{"copy":copy,"save":save,"remove":remove})]}}],null,true)})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }